import React, { useCallback, useEffect, useState } from 'react';
import { FieldComponent } from '../../../types/FieldComponent';
import { TimeFilter } from '../filters/TimeFilter';
import {
  Checkbox,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';

import { debounce } from 'lodash';
import api from '../../../services/api';
import { SPNumberField } from './SPNumberField';
import { SPSelectField } from './SPSelectField';
import { enumItems } from '../../../schema/enumItems';
import Box from '@mui/material/Box';

const label = { inputProps: { 'aria-label': 'Switch demo' } };

export const CustomFieldForServiceProviderEventStaffService: FieldComponent<
  any,
  any
> = ({
  onChange,
  isActive,
  value,
  defaultValue,
  allValue,
  hasTooltip,
  disabled,
  column,
}) => {
  const [services, setServices] = useState<any>([]);
  const [currentState, setCurrentState] = useState<any>({
    value: {},
    send: false,
  });
  const [availableRows, setAvailableRows] = useState<any>([]);

  const debouncedChange = useCallback(
    debounce((newValue) => {
      onChange(newValue);
    }, 500),
    []
  );

  const debouncedChangeInput = useCallback(
    debounce((index, column, value) => {
      setAvailableRows((prevRows: any) => {
        const updatedRows = [...prevRows];
        if (updatedRows[index]) {
          updatedRows[index][column] = value;
        }
        return updatedRows;
      });
    }, 200),
    []
  );

  const fetchServices = useCallback(() => {
    if (allValue?.service_provider?.id) {
      const searchParams = new URLSearchParams({});

      const servicesResponse = api
        .get(
          `/service-provider-services/${allValue?.service_provider?.id}`,
          searchParams
        )
        .then((res: any) => {
          setServices(res.data);

          const available: any = [];
          res.data.map((row: any) => {
            const saveData: any = {
              checked: false,
              cost: null,
              currency: null,
            };
            if (defaultValue) {
              defaultValue.map((item: any) => {
                if (item.service.id === row?.id) {
                  saveData.checked = true;
                  saveData.cost = item.cost;
                  saveData.currency = item.currency;
                }
              });
            }

            available.push({
              ...allValue,
              service: row,
              checked: saveData.checked,
              cost: saveData.cost,
              currency: saveData.currency,
            });
          });

          setAvailableRows(available);
        });
    } else {
      setServices([]);
    }
  }, [allValue]);

  useEffect(() => {
    fetchServices();
  }, []);

  useEffect(() => {
    if (currentState.send) {
      debouncedChange(currentState.value);
    }
  }, [currentState, debouncedChange]);

  const handleSelectAll = (selectAll: boolean) => {
    setAvailableRows((prevRows: any) => {
      return prevRows.map((row: any) => ({
        ...row,
        checked: selectAll,
      }));
    });
  };

  const logAvailableRows = useCallback(
    debounce(() => {
      onChange(availableRows);
    }, 300),
    [availableRows]
  );

  useEffect(() => {
    logAvailableRows();
    return () => {
      logAvailableRows.cancel();
    };
  }, [availableRows, logAvailableRows]);

  return (
    <>
      {services ? (
        <>
          <Box
            sx={{
              p: '10px',
            }}
          >
            <Typography>Services</Typography>
            <TableContainer
              component={Paper}
              sx={{
                borderRadius: '0px',
                width: '100% !important',
              }}
            >
              <Table size="small">
                <TableHead
                  sx={{
                    '& .MuiTableCell-root': {
                      color: 'inherit',
                      border: 'none',
                    },
                    '& .MuiTableRow-root .MuiTableCell-root.MuiTableCell-head': {
                      border: 'none',
                      fontSize: '14px',
                      p: '10px',
                    },
                    background: '#f1f1f1',
                    borderBottom: '1px solid #dfdbdb',
                  }}
                >
                  <TableRow
                    sx={{
                      '& .MuiTableCell-root': {
                        overflowWrap: 'anywhere',
                      },
                    }}
                  >
                    <TableCell
                      sx={{
                        maxWidth: '50px',
                      }}
                    >
                      <Checkbox
                        {...label}
                        onChange={(event, checked) => {
                          handleSelectAll(checked);
                        }}
                      />
                    </TableCell>
                    <TableCell
                      sx={{
                        maxWidth: '150px',
                      }}
                    >
                      Service
                    </TableCell>
                    <TableCell>Cost</TableCell>
                    <TableCell>Currency</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {services.map((row: any, index: number) => {
                    let defaultRowData: any = null;

                    if (defaultValue) {
                      defaultValue.map((defaultValueRow: any) => {
                        if (defaultValueRow?.service?.id === row?.id) {
                          defaultRowData = defaultValueRow;
                        }
                      });
                    }
                    return (
                      <TableRow>
                        <TableCell sx={{ borderRight: '1px solid #f2f2f2' }}>
                          <Checkbox
                            {...label}
                            checked={availableRows[index].checked}
                            onChange={(event, checked) => {
                              debouncedChangeInput(index, 'checked', checked);
                            }}
                          />
                        </TableCell>

                        <TableCell sx={{ borderRight: '1px solid #f2f2f2' }}>
                          {row?.name}
                        </TableCell>
                        <TableCell sx={{ borderRight: '1px solid #f2f2f2' }}>
                          <SPNumberField
                            disabled={false}
                            onChange={(value) => {
                              debouncedChangeInput(index, 'cost', value);
                            }}
                            defaultValue={
                              defaultRowData ? defaultRowData.cost : null
                            }
                            isActive={true}
                          />
                        </TableCell>
                        <TableCell>
                          <SPSelectField
                            onChange={(value) => {
                              debouncedChangeInput(index, 'currency', value);
                            }}
                            schema={enumItems.currency}
                            defaultValue={
                              defaultRowData ? defaultRowData.currency : null
                            }
                            forcedValue={null}
                            disabled={false}
                            isMissing={false}
                            accordingToValue={null}
                          />
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </>
      ) : (
        <></>
      )}
    </>
  );
};

CustomFieldForServiceProviderEventStaffService.includes = (query, value) =>
  true;

CustomFieldForServiceProviderEventStaffService.comparator = () => 0;

CustomFieldForServiceProviderEventStaffService.FilterRenderer = TimeFilter;
